export { default as StopSolidIcon } from './StopSolidIcon';
